'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$0024 from "./presto.-Login-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002445 from "./presto.-Presto-Router$$anon$45.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$44() {
  this.bhK = null;
  this.bhC = null;
  this.bhD = false;
  this.bhL = null;
  this.bhM = false;
  this.bhP = null;
  this.bhI = null;
  this.bhJ = false;
  this.bhE = null;
  this.bhF = false;
  this.bhG = null;
  this.bhH = false;
  this.bhN = false;
  this.bhO = false;
  this.bhK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bhP = "LoginPage";
}
export { $c_Lpresto_PrestoRouter$$anon$44 as $c_Lpresto_PrestoRouter$$anon$44 };
$p = $c_Lpresto_PrestoRouter$$anon$44.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$44;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$44() {
}
export { $h_Lpresto_PrestoRouter$$anon$44 as $h_Lpresto_PrestoRouter$$anon$44 };
$h_Lpresto_PrestoRouter$$anon$44.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bhK;
});
$p.M = (function() {
  if ((!this.bhD)) {
    this.bhC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bhD = true;
  }
  return this.bhC;
});
$p.O = (function() {
  if ((!this.bhM)) {
    this.bhL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bhM = true;
  }
  return this.bhL;
});
$p.E = (function() {
  return this.bhP;
});
$p.t = (function() {
  if ((!this.bhJ)) {
    this.bhI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhJ = true;
  }
  return this.bhI;
});
$p.N = (function() {
  if ((!this.bhF)) {
    this.bhE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhF = true;
  }
  return this.bhE;
});
$p.Q = (function() {
  if ((!this.bhH)) {
    this.bhG = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002445.$c_Lpresto_PrestoRouter$$anon$45();
    this.bhH = true;
  }
  return this.bhG;
});
$p.v = (function() {
  if ((!this.bhO)) {
    this.bhN = false;
    this.bhO = true;
  }
  return this.bhN;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee370) => ((p) => \u03b4scrutinee370))($j_presto$002e$002dLogin$002dPage$0024.$m_Lpresto_LoginPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$44 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$44, "presto.PrestoRouter$$anon$44", ({
  Ok: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$44 as $d_Lpresto_PrestoRouter$$anon$44 };
//# sourceMappingURL=presto.-Presto-Router$$anon$44.js.map
